import Collapse from '@mui/material/Collapse';
import { useCss, useToggle } from 'react-use';
import ExpandDownArrow from '../DesignSystems/buttons/ExpandDownArrow';
import ExpandRightArrow from '../DesignSystems/buttons/ExpandRightArrow';
import Dropdown from 'react-bootstrap/Dropdown';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../SharedIcon/SharedIcon';

type EntityListProps<T extends any[] = any[]> = {
  entities: T | undefined;
  header: JSX.Element;
  renderEntity: (entity: T[number]) => JSX.Element;
  expanded: boolean;
  toggleExpanded: () => void;
  toggleAdd?: () => void;
  customItem?: () => void;
  customItemTitle?: string;
};

const EntityList = <T extends any[]>({
  entities,
  header,
  renderEntity,
  expanded,
  toggleExpanded,
  toggleAdd,
  customItem,
  customItemTitle,
}: EntityListProps<T>) => {
  const [viewArchived, setViewArchived] = useToggle(false);

  const filteredEntities = entities?.filter((fe) => {
    // If the entity doesn't have an archived property, show it when viewArchived is false
    if (fe.archived === undefined) {
      return !viewArchived;
    }
    // Otherwise, filter based on the archived property matching viewArchived state
    return fe.archived === viewArchived;
  });

  const listStyle = useCss({
    paddingLeft: '1.375rem',
    marginLeft: '0.625rem',
  });

  return (
    <div className="w-100">
      <div className="w-100 d-flex align-items-center mb-2">
        {filteredEntities?.length ? (
          <div>
            {expanded ? (
              <ExpandDownArrow onClick={toggleExpanded} />
            ) : (
              <ExpandRightArrow onClick={toggleExpanded} />
            )}
          </div>
        ) : (
          <div className="ms-2 me-3"></div>
        )}
        {viewArchived ? '(Inactive) - ' : ''} {header}
        <Dropdown>
          <Dropdown.Toggle as={StylishNewButton} className="button--link">
            <SharedIcon iconName="more_vert" color="light" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {toggleAdd && (
              <Dropdown.Item as="button" onClick={toggleAdd}>
                <SharedIcon iconName="add" color="light" />
                Add
              </Dropdown.Item>
            )}
            {customItem && customItemTitle && (
              <Dropdown.Item as="button" onClick={customItem}>
                {customItemTitle}
              </Dropdown.Item>
            )}

            <Dropdown.Item as="button" onClick={setViewArchived}>
              {viewArchived ? 'View Active' : 'View Inactive'}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Collapse in={expanded}>
        <div className={listStyle}>
          {filteredEntities?.map((entity) => renderEntity(entity))}
        </div>
      </Collapse>
    </div>
  );
};

export default EntityList;
